





























































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { storeVisumEtRepertum } from "@/store/modules/VisumEtRepertumStore";
import SvcVisumEtRepertum from "@/services/VisumEtRepertum";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import SectionVerHidup from "./SectionVerHidup.vue";
import SectionVerMati from "./SectionVerMati.vue";

@Component({
  components: {
    CardModalTtd,
    PersonAutoComplete,
    SectionVerHidup,
    SectionVerMati,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardVisumEtRepertum extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("visum_et_repertum", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("visum_et_repertum", "edit");
  }

  storeVisum = storeVisumEtRepertum;
  showForm = false;
  showDetail = false;
  valid = true;
  saving = false;
  isEdit = false;
  editId: number | null = null;

  dialogHapus = false;
  hapusTarget: any = null;

  openPanels = [0, 1, 2, 3, 4];

  form: any = this.getDefaultForm();

  tableHeaders = [
    { text: "Nomor VR", value: "nomor_ver" },
    { text: "Jenis", value: "jenis_ver" },
    { text: "Tgl Periksa", value: "tanggal_pemeriksaan" },
    { text: "Status", value: "signed" },
    { text: "Aksi", value: "actions", sortable: false, width: "180px" },
  ];

  // — master pilihan (spec rme_VeR_template v1.0.0)
  jenisVisumItems = [
    { text: "VeR Perlukaan", value: "perlukaan" },
    { text: "VeR Kejahatan Susila", value: "kejahatan-susila" },
    { text: "VeR Psikiatrik", value: "psikiatrik" },
    { text: "VeR Keracunan", value: "keracunan" },
    { text: "VeR Pemeriksaan Luar Jenazah", value: "pemeriksaan-luar-jenazah" },
    { text: "VeR Pemeriksaan Dalam (Autopsi)", value: "autopsi" },
    { text: "VeR Penggalian Mayat (Eksumasi)", value: "eksumasi" },
  ];
  caraSpvItems = [
    { text: "Diantar langsung", value: "diantar-langsung" },
    { text: "Pos resmi", value: "pos-resmi" },
    { text: "E-mail dinas", value: "email-dinas" },
    { text: "SPV digital ber-TTE tersertifikasi", value: "spv-digital" },
  ];
  labelPolisiItems = [
    { text: "Cocok dengan SPV", value: "cocok" },
    { text: "TIDAK cocok dengan SPV", value: "tidak_cocok" },
    { text: "Tidak ada label", value: "tidak_ada" },
  ];
  sumberAnamnesisItems = [
    { text: "Korban sendiri", value: "korban" },
    { text: "Wali", value: "wali" },
    { text: "Penyidik", value: "penyidik" },
    { text: "Saksi pengantar", value: "saksi_pengantar" },
  ];
  pelakuItems = [
    { text: "Dikenal", value: "dikenal" },
    { text: "Tidak dikenal", value: "tidak_dikenal" },
    { text: "Tidak ditanya", value: "tidak_ditanya" },
  ];
  jenisKekerasanItems = [
    { text: "Fisik", value: "fisik" },
    { text: "Seksual", value: "seksual" },
    { text: "Verbal", value: "verbal" },
    { text: "Penelantaran", value: "penelantaran" },
  ];
  autopsiPersetujuanItems = [
    { text: "Persetujuan keluarga", value: "persetujuan-keluarga" },
    { text: "Perintah penyidik (pasca 2×24 jam)", value: "perintah-penyidik" },
  ];
  derajatLukaItems = [
    { text: "Ringan (tidak menghalangi pekerjaan)", value: "ringan" },
    { text: "Sedang (halangan sementara)", value: "sedang" },
    { text: "Berat (luka berat KUHP)", value: "berat" },
  ];
  fotoKategoriItems = [
    { text: "Luka — overview", value: "luka_overview" },
    { text: "Luka — close-up (dengan penggaris)", value: "luka_closeup" },
    { text: "Sketsa tubuh", value: "sketsa_tubuh" },
    { text: "Wajah jenazah", value: "wajah_jenazah" },
    { text: "Identifikasi", value: "identifikasi" },
    { text: "Scan Surat Permintaan Visum", value: "spv_scan" },
    { text: "Lainnya", value: "lainnya" },
  ];
  regioItems = [
    "kepala", "leher", "dada", "perut", "punggung", "pinggang", "pantat",
    "anggota gerak atas kanan", "anggota gerak atas kiri",
    "anggota gerak bawah kanan", "anggota gerak bawah kiri", "genital", "dubur",
  ];
  bentukLukaItems = [
    "luka lecet", "memar", "luka terbuka", "luka tertutup", "bengkak",
    "luka bakar", "patah tulang (klinis)", "jejas",
  ];
  woundTimingItems = [
    { text: "Ante-mortem", value: "ante_mortem" },
    { text: "Post-mortem", value: "post_mortem" },
  ];
  statusLukaItems = [
    { text: "Belum sembuh", value: "belum_sembuh" },
    { text: "Dalam proses penyembuhan", value: "proses_penyembuhan" },
    { text: "Sembuh dengan jaringan parut", value: "sembuh_parut" },
  ];

  // — state luka / foto / TTD
  modalTtd = false;
  dialogLuka = false;
  savingLuka = false;
  uploadingFoto = false;
  lukaForm: any = this.getDefaultLukaForm();
  fotoUpload: any = { kategori: "luka_overview", visum_luka_id: null, file: null };

  get listVisum() {
    return this.storeVisum.listVisum;
  }

  get allDokter() {
    return storeDokter.listAll;
  }

  get bolehTtd(): boolean {
    if (this.readOnly) return false;
    const user = userModule.user;
    return !!user && !!this.form.dokter_pemeriksa_id && user.id === this.form.dokter_pemeriksa_id;
  }

  get lukaSelectItems() {
    return (this.form.lukas || []).map((l: any) => ({
      text: `${l.kode_luka} — ${l.lokasi_spesifik}`,
      value: l.id,
    }));
  }

  getDefaultLukaForm() {
    return {
      id: null,
      regio: null,
      lokasi_spesifik: "",
      koordinat: "",
      bentuk: null,
      panjang_cm: null,
      lebar_cm: null,
      panjang_dirapatkan_cm: null,
      kedalaman_cm: null,
      tepi: "",
      sudut: "",
      dasar: "",
      warna: "",
      permukaan_sekitar: "",
      status_luka: null,
      estimasi_usia_luka: "",
      icd10: "",
      wound_timing: null,
      reaksi_vital: "",
      catatan: "",
    };
  }

  getDefaultForm() {
    return {
      jenis_ver: "",
      status_dokumen: "original",
      instansi_kepolisian: "",
      nama_penyidik: "",
      pangkat_penyidik: "",
      nrp_penyidik: "",
      nomor_surat_permintaan: "",
      tanggal_surat_permintaan: "",
      tim_medis: "",
      dokter_pemeriksa_id: null,
      tanggal_pemeriksaan: localISODate(),
      jam_mulai: "",
      jam_selesai: "",
      lokasi_pemeriksaan: "",
      pekerjaan_korban: "",
      kewarganegaraan: "WNI",
      agama_korban: "",
      alamat_korban: "",
      hari_kejadian: "",
      tanggal_kejadian: "",
      jam_kejadian: "",
      lokasi_kejadian: "",
      uraian_kejadian: "",
      kondisi_saat_ditemukan: "",
      riwayat_datang: "",
      // VeR Hidup
      kesadaran: "",
      gcs_e: null,
      gcs_m: null,
      gcs_v: null,
      td_sistolik: null,
      td_diastolik: null,
      nadi: "",
      pernapasan: "",
      suhu: "",
      tinggi_badan: null,
      berat_badan: null,
      pakaian: "",
      pf_kepala: "",
      pf_leher: "",
      pf_dada: "",
      pf_punggung: "",
      pf_perut: "",
      pf_pinggang: "",
      pf_pantat: "",
      pf_dubur: "",
      pf_alat_kelamin: "",
      pf_anggota_gerak_atas_kanan: "",
      pf_anggota_gerak_atas_kiri: "",
      pf_anggota_gerak_bawah_kanan: "",
      pf_anggota_gerak_bawah_kiri: "",
      pemeriksaan_mental: "",
      pemeriksaan_penunjang: "",
      // VeR Mati
      pl_keadaan_jenazah: "",
      pl_sikap_jenazah: "",
      pl_rigor_mortis: "",
      pl_livor_mortis: "",
      pl_dekomposisi: "",
      pl_berat_jenazah: null,
      pl_panjang_jenazah: null,
      pl_kepala: { rambut: "", bawah_rambut: "", dahi: "", mata_kanan: "", mata_kiri: "", hidung: "", mulut: "", dagu: "", pipi: "", telinga: "" },
      pl_leher: "",
      pl_dada: "",
      pl_perut: "",
      pl_alat_kelamin: "",
      pl_anggota_gerak_atas: { kanan: { lengan_atas: "", lengan_bawah: "", tangan: "" }, kiri: { lengan_atas: "", lengan_bawah: "", tangan: "" } },
      pl_anggota_gerak_bawah: { kanan: { paha: "", tungkai_bawah: "", kaki: "" }, kiri: { paha: "", tungkai_bawah: "", kaki: "" } },
      pl_punggung: "",
      pl_pantat: "",
      pl_dubur: "",
      pd_kulit_dada: "",
      pd_rongga_dada: "",
      pd_jantung: "",
      pd_paru_kanan: "",
      pd_paru_kiri: "",
      pd_rongga_perut: "",
      pd_hati: "",
      pd_limpa: "",
      pd_ginjal_kanan: "",
      pd_ginjal_kiri: "",
      pd_lambung: "",
      pd_usus: "",
      pd_leher: "",
      pd_kepala: "",
      pd_otak: "",
      lab_golongan_darah: "",
      lab_narkoba: "",
      lab_covid: "",
      lab_histopatologi: [],
      // Kesimpulan
      kesimpulan: "",
      tempat_tanda_tangan: "Bantul",
      tanggal_tanda_tangan: localISODate(),
      dokter_pemeriksa_nama: "",
      dokter_pemeriksa_spesialisasi: "",
      // — spec rme_VeR_template v1.0.0
      jabatan_penyidik: "",
      alamat_kesatuan: "",
      jenis_visum_diminta: null,
      dugaan_tindak_pidana: "",
      cara_penerimaan_spv: null,
      tanggal_terima_spv: "",
      petugas_penerima_spv: "",
      nik_korban: "",
      nomor_jenazah: "",
      status_perkawinan_korban: "",
      catatan_identifikasi: "",
      wali_nama: "",
      wali_hubungan: "",
      wali_nik: "",
      wali_kontak: "",
      cara_datang: "",
      label_polisi_status: null,
      label_polisi_catatan: "",
      sumber_anamnesis: null,
      keluhan_utama: "",
      riwayat_penyakit_dahulu: "",
      riwayat_alergi: "",
      riwayat_obat: "",
      hpht: "",
      riwayat_pasca_kejadian: "",
      jenis_kekerasan: [],
      pelaku_dikenal: null,
      pembungkus_jenazah: "",
      tanda_pengenal_jenazah: "",
      pl_algor_suhu_rektal: null,
      estimasi_saat_kematian: "",
      autopsi_persetujuan_jenis: null,
      autopsi_penandatangan: "",
      autopsi_hubungan: "",
      pd_tulang_tengkorak: "",
      pd_selaput_otak: "",
      pd_otot_leher: "",
      pd_os_hyoid: "",
      pd_rawan_tiroid_krikoid: "",
      pd_trakea_esofagus: "",
      pd_tulang_iga_sternum: "",
      pd_pembuluh_besar: "",
      derajat_luka: null,
      jenis_kekerasan_penyebab: "",
      sebab_kematian: "",
      mekanisme_kematian: "",
      perkiraan_saat_kematian: "",
    };
  }

  formatDate(d) {
    if (!d) return "-";
    const dt = new Date(d);
    return dt.toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  tambahVisum() {
    this.form = this.getDefaultForm();

    // Auto-fill dari data dokter login
    const user = userModule.user;
    if (user && user.id) {
      this.form.dokter_pemeriksa_id = user.id;
      this.form.dokter_pemeriksa_nama = user.nama || "";
      this.form.dokter_pemeriksa_spesialisasi = user.profesi || "";
    }

    // Auto-fill dari data pasien
    const pasien = storePasien.identitasPasien;
    if (pasien) {
      this.form.pekerjaan_korban = pasien.pekerjaan || "";
      this.form.agama_korban = pasien.agama || "";
      this.form.alamat_korban = pasien.alamat || "";
      this.form.kewarganegaraan = pasien.warga_negara || "WNI";
    }

    this.isEdit = false;
    this.editId = null;
    this.showForm = true;
    this.showDetail = false;
  }

  async editVisum(item) {
    if (item.signed) {
      appModule.sendErrorAlert("Visum sudah ditandatangani — dokumen pro justitia tidak dapat diubah.");
      return;
    }
    try {
      const resp = await SvcVisumEtRepertum.getById(item.id);
      const data = resp.data;
      this.form = {
        ...this.getDefaultForm(),
        ...data,
        jenis_kekerasan: data.jenis_kekerasan || [],
        pl_kepala: data.pl_kepala || { rambut: "", bawah_rambut: "", dahi: "", mata_kanan: "", mata_kiri: "", hidung: "", mulut: "", dagu: "", pipi: "", telinga: "" },
        pl_anggota_gerak_atas: data.pl_anggota_gerak_atas || { kanan: { lengan_atas: "", lengan_bawah: "", tangan: "" }, kiri: { lengan_atas: "", lengan_bawah: "", tangan: "" } },
        pl_anggota_gerak_bawah: data.pl_anggota_gerak_bawah || { kanan: { paha: "", tungkai_bawah: "", kaki: "" }, kiri: { paha: "", tungkai_bawah: "", kaki: "" } },
        lab_histopatologi: data.lab_histopatologi || [],
      };
      this.editId = item.id;
      this.isEdit = true;
      this.showForm = true;
      this.showDetail = false;
    } catch (e) {
      // error handled by service
    }
  }

  async lihatDetail(item) {
    try {
      const resp = await SvcVisumEtRepertum.getById(item.id);
      this.form = resp.data;
      this.showDetail = true;
      this.showForm = false;
    } catch (e) {
      // error handled by service
    }
  }

  backToList() {
    this.showForm = false;
    this.showDetail = false;
    this.form = this.getDefaultForm();
  }

  async simpan() {
    if (!(this.$refs.form as any).validate()) return;

    this.saving = true;
    try {
      const payload = {
        ...this.form,
        register_id: this.register,
        pasien_rm: this.rm,
      };

      if (this.isEdit && this.editId) {
        await SvcVisumEtRepertum.put(this.editId, payload);
      } else {
        await SvcVisumEtRepertum.post(payload);
      }

      await this.storeVisum.getByRegister(this.register);
      this.backToList();
    } catch (e) {
      // error handled by service
    } finally {
      this.saving = false;
    }
  }

  cetakVisum(item) {
    SvcVisumEtRepertum.print(item.id);
  }

  hapusVisum(item) {
    this.hapusTarget = item;
    this.dialogHapus = true;
  }

  async confirmHapus() {
    if (!this.hapusTarget) return;
    try {
      await SvcVisumEtRepertum.destroy(this.hapusTarget.id);
      await this.storeVisum.getByRegister(this.register);
    } catch (e) {
      // error handled by service
    }
    this.dialogHapus = false;
    this.hapusTarget = null;
  }

  // ── Inventaris luka

  bukaDialogLuka(luka) {
    this.lukaForm = luka ? { ...this.getDefaultLukaForm(), ...luka } : this.getDefaultLukaForm();
    this.dialogLuka = true;
  }

  async simpanLuka() {
    if (!this.form.id) return;
    this.savingLuka = true;
    try {
      const payload = { ...this.lukaForm };
      if (payload.id) {
        await SvcVisumEtRepertum.updateLuka(this.form.id, payload.id, payload);
      } else {
        await SvcVisumEtRepertum.addLuka(this.form.id, payload);
      }
      this.dialogLuka = false;
      await this.refreshDetail();
    } catch (e) {
      // error handled by service
    } finally {
      this.savingLuka = false;
    }
  }

  async hapusLuka(luka) {
    try {
      await SvcVisumEtRepertum.deleteLuka(this.form.id, luka.id);
      await this.refreshDetail();
    } catch (e) {
      // error handled by service
    }
  }

  // ── Foto dokumentasi

  async unggahFoto() {
    if (!this.form.id || !this.fotoUpload.file) return;
    this.uploadingFoto = true;
    try {
      await SvcVisumEtRepertum.uploadFoto(this.form.id, this.fotoUpload.file, {
        kategori: this.fotoUpload.kategori,
        visum_luka_id: this.fotoUpload.visum_luka_id,
      });
      this.fotoUpload.file = null;
      await this.refreshDetail();
    } catch (e) {
      // error handled by service
    } finally {
      this.uploadingFoto = false;
    }
  }

  async hapusFoto(foto) {
    try {
      await SvcVisumEtRepertum.deleteFoto(this.form.id, foto.id);
      await this.refreshDetail();
    } catch (e) {
      // error handled by service
    }
  }

  fotoKategoriLabel(val) {
    const found = this.fotoKategoriItems.find(i => i.value === val);
    return found ? found.text : val;
  }

  kodeLukaOf(lukaId) {
    const found = (this.form.lukas || []).find((l: any) => l.id === lukaId);
    return found ? found.kode_luka : "";
  }

  async refreshDetail() {
    if (!this.form.id) return;
    const resp = await SvcVisumEtRepertum.getById(this.form.id);
    this.form = resp.data;
  }

  // ── TTD digital dokter pemeriksa

  async passTtd(password: string) {
    if (!this.form.id) return;
    try {
      const resp = await SvcVisumEtRepertum.signDokter(this.form.id, { password });
      if (resp.data && resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil menandatangani Visum et Repertum");
        appModule.addMsgTtd("");
        await this.refreshDetail();
        await this.storeVisum.getByRegister(this.register);
      }
    } catch (e) {
      // error handled by service
    }
  }

}
